"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAndSubmit = exports.updateFormField = exports.VALIDATE_AND_SUBMIT = exports.UPDATE_FORM_FIELD = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _validators = _interopRequireDefault(require("./validators"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
exports.UPDATE_FORM_FIELD = UPDATE_FORM_FIELD;
var VALIDATE_AND_SUBMIT = 'VALIDATE_AND_SUBMIT';
exports.VALIDATE_AND_SUBMIT = VALIDATE_AND_SUBMIT;
var validateAndSubmit = function validateAndSubmit() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState) {
      var _getState, siteInfo, form, realm, basePath, formFields, loanId, postURL, email, password, confirmPassword, postEndPoint, pVal, cPVal, postData, responseData;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), siteInfo = _getState.siteInfo, form = _getState.form;
            realm = siteInfo.realm, basePath = siteInfo.basePath;
            formFields = form.formFields, loanId = form.loanId, postURL = form.postURL;
            email = formFields.email, password = formFields.password, confirmPassword = formFields.confirmPassword;
            postEndPoint = "".concat(basePath).concat(postURL);
            pVal = password.value;
            cPVal = confirmPassword.value;
            if (!(pVal === '' || cPVal === '' || pVal !== cPVal)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", dispatch({
              type: VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                genericError: 'Password, Confirm Password cannot be empty or unequal'
              }
            }));
          case 9:
            _context.prev = 9;
            postData = {
              email: email.value,
              siteAuthorization: 'patient',
              site: realm,
              status: 'Active',
              password: password.value,
              name: 'Approve Bond',
              loanId: loanId
            };
            _context.next = 13;
            return _lcHttp.default.post(postEndPoint, postData);
          case 13:
            responseData = _context.sent;
            if (!(responseData.data['account-create-login'] === 'OK')) {
              _context.next = 16;
              break;
            }
            return _context.abrupt("return", dispatch({
              type: VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: true,
                genericError: ''
              }
            }));
          case 16:
            return _context.abrupt("return", dispatch({
              type: VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                genericError: [responseData.data['account-create-login']]
              }
            }));
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](9);
            return _context.abrupt("return", dispatch({
              type: VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                genericError: 'There was an error creating an account. Please try again.'
              }
            }));
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 19]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
exports.validateAndSubmit = validateAndSubmit;
var updateFormField = function updateFormField() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState) {
      var _getState2, form, formFields, event, targetField, focusElement, vFns, errors;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _getState2 = getState(), form = _getState2.form;
            formFields = form.formFields;
            event = args[0];
            event.persist();
            targetField = _objectSpread({}, formFields[event.target.name]);
            focusElement = event.target.name;
            targetField.value = event.target.value;
            vFns = _validators.default[focusElement];
            errors = [];
            vFns.forEach(function (fn) {
              var err = fn(event.target.value, {
                message: 'Please follow the helper instructions to enter a valid input'
              });
              if (err && errors.indexOf(err) === -1) {
                errors.push(err);
              }
            });
            targetField.errors = errors;
            formFields[event.target.name] = targetField;
            return _context2.abrupt("return", dispatch({
              type: UPDATE_FORM_FIELD,
              payload: {
                currentFocus: focusElement,
                genericError: '',
                formFields: formFields
              }
            }));
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.updateFormField = updateFormField;
